import { LuxTypography } from '@gemini/fe-ds-core';
import { ReactNode } from 'react';
import { RowWrapper, TableWrapper } from './DataGeneralTable.styles';

interface DataTableProps {
  rowFill?: 'odd' | 'even' | 'none';
  rows: string[][] | ReactNode[][];
  columnsTemplate: string;
}

const DataGeneralTable = ({
  rowFill = 'none',
  rows,
  columnsTemplate,
}: DataTableProps) => {
  return (
    <TableWrapper rowFill={rowFill}>
      {rows.map((row, index) => (
        <RowWrapper key={index} columnsTemplate={columnsTemplate}>
          {row.map(el => {
            return typeof el === 'string' ? (
              <LuxTypography>{el}</LuxTypography>
            ) : (
              el
            );
          })}
        </RowWrapper>
      ))}
    </TableWrapper>
  );
};

export default DataGeneralTable;
